import { render, staticRenderFns } from "./SelectChannel.vue?vue&type=template&id=21522fb0&scoped=true"
import script from "./SelectChannel.vue?vue&type=script&lang=js"
export * from "./SelectChannel.vue?vue&type=script&lang=js"
import style0 from "./SelectChannel.vue?vue&type=style&index=0&id=21522fb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21522fb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21522fb0')) {
      api.createRecord('21522fb0', component.options)
    } else {
      api.reload('21522fb0', component.options)
    }
    module.hot.accept("./SelectChannel.vue?vue&type=template&id=21522fb0&scoped=true", function () {
      api.rerender('21522fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/SelectChannel.vue"
export default component.exports